import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "lang--voice" }
const _hoisted_2 = {
  key: 0,
  class: "placeholder"
}
const _hoisted_3 = ["data-placeholder", "onchange"]

import { handlePaste } from '@/utils/handlePaste'
import enLangFile from '@/lang/translations/en.json'
import { onMounted, ref, watchEffect } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomTextArea',
  props: {
  label: {
    type: String,
    default: ''
  },
  maxLength: {
    type: Number,
    default: 2500
  },
  selectedTitle: {
    type: String
  },
  languageName: {
    type: String
  },
  voiceName: {
    type: Object
  },
  placeholder: {
    type: String
  },
  userSelectedVoice: {
    type: String
  }
},
  setup(__props) {

const props = __props

const textArea = ref(null)
const { t } = useI18n()
const placeholderText = ref(true)
const { _invalidVoiceNames: invalidVoiceNames } = enLangFile

const textareaFocus = () => {
  textArea.value.focus()
}

const changeTagsClass = (selectedTitle) => {
  const selectedClass = selectedTitle.toLowerCase()
  const tabClasses = ['voice', 'speed', 'pitch', 'silence', 'emphasis']

  for (let i = tabClasses.length; i > 0; i--) {
    const elementList = document.getElementsByClassName(tabClasses[i - 1])

    if (t('_tabNames.' + tabClasses[i - 1]).toLocaleLowerCase() == selectedClass) {
      // for the tags matching the selected Tab
      for (let j = elementList.length; j > 0; j--) {
        elementList[j - 1].className += ' cream-teal' // highlight the tags in text-area
      }
    } else {
      for (let j = elementList.length; j > 0; j--) {
        elementList[j - 1].className = elementList[j - 1].className.replace('cream-teal', '') // UN-highlight the tags in text-area
      }
    }
  }
}

watchEffect(() => {
  props.selectedTitle
  changeTagsClass(props.selectedTitle)
})

onMounted(() => {
  document.addEventListener('click', () => {
    // document.addEventListener("paste", handlePaste);
    if (document.activeElement != textArea.value && textArea.value !== null) {
      if (textArea.value.innerText.length > 1) {
        placeholderText.value = false
        // silenceApply.disabled = true;
      } else {
        placeholderText.value = true
      }
    } else {
      placeholderText.value = false
    }
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "container",
    onClick: textareaFocus
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass(["lang", { 'cream-teal': __props.selectedTitle == _ctx.$t('_tabNames.voice') }])
      }, _toDisplayString(_ctx.$t('_labels.language')) + " : " + _toDisplayString(__props.languageName), 3),
      _createElementVNode("span", {
        class: _normalizeClass(["lang", { 'cream-teal': __props.selectedTitle == _ctx.$t('_tabNames.voice') }])
      }, _toDisplayString(_ctx.$t('_labels.voice')) + " : " + _toDisplayString(__props.userSelectedVoice && _unref(invalidVoiceNames)[__props.userSelectedVoice] && !__props.voiceName.voiceIndex
            ? _ctx.$t(`_invalidVoiceNames.${__props.userSelectedVoice}`)
            : __props.voiceName.voiceIndex
              ? __props.voiceName.voiceIndex + '. ' + __props.voiceName.voiceLabel
              : 'Invalid'), 3)
    ]),
    (placeholderText.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.placeholder), 1))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      ref_key: "textArea",
      ref: textArea,
      class: "tarea",
      contenteditable: "true",
      label: "text",
      "data-placeholder": __props.placeholder,
      onchange: 
        () => {
          textArea.value.parentElement.normalize()
        }
      ,
      onKeyup: _cache[0] || (_cache[0] = ($event) => _ctx.$emit('onKeyUp', $event)),
      onKeypress: _cache[1] || (_cache[1] = ($event) => _ctx.$emit('onKeyPress', $event)),
      onPaste: _cache[2] || (_cache[2] = _withModifiers(
        ($event) => {
          _unref(handlePaste)($event, __props.maxLength), _ctx.$emit('onKeyUp', $event)
        }
      , ["prevent"])),
      onCopy: _cache[3] || (_cache[3] = ($event) => _ctx.$emit('onCutOrCopy', $event)),
      onCut: _cache[4] || (_cache[4] = ($event) => _ctx.$emit('onCutOrCopy', $event))
    }, "​ ", 40, _hoisted_3)
  ]))
}
}

})